var _rect, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVtb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 169,
    viewBox: "0 0 276 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 169,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_41420)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1921 66L90.393 70.9321H115.325L117.124 66H92.1921ZM89.4928 73.397L87.6937 78.3279H112.626L114.425 73.397H89.4928ZM86.7992 80.794L85 85.7249H109.932L111.73 80.794H86.7992Z",
    fill: "#9B9FB3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2824_41420",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 73,
    width: 69,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.406 103.704H190.655V73.4922H122.406V103.704Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2824_41420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.004 87.6048V87.7088C139.144 88.1274 140.232 88.8593 140.802 89.3293C142.564 90.793 143.342 92.7268 143.342 95.2357C143.342 99.3662 141.165 102.345 137.589 103.286C136.501 103.6 135.362 103.705 133.236 103.705H122.406V73.4922H131.993C133.963 73.4922 135.309 73.5963 136.501 73.9096C139.974 74.8507 142.254 77.2556 142.254 81.0705C142.254 83.1095 141.528 84.8351 140.336 85.9844C139.818 86.507 139.093 87.1348 138.004 87.6048ZM128.417 90.793V98.7384H132.563C133.806 98.7384 134.947 98.6344 135.777 97.8499C136.605 97.0654 136.968 96.0728 136.968 94.7657C136.968 93.7731 136.708 92.832 136.19 92.1527C135.309 91.0549 134.221 90.793 132.356 90.793H128.417ZM128.365 85.5658H131.734C132.77 85.5658 133.288 85.5658 133.806 85.4092C135.206 84.9906 136.087 83.7373 136.087 82.0117C136.087 79.9739 135.154 79.0842 133.806 78.6668C133.236 78.5101 132.667 78.4575 131.526 78.4575H128.365V85.5658ZM152.359 103.705V78.5616H143.705V73.4922H167.75L166.041 78.5616H158.37V103.705H152.359ZM169.615 103.705V73.4922H189.101L187.391 78.5616H175.576V85.2525H180.395C184.282 85.2525 186.303 86.1936 187.702 87.3955C188.79 88.3367 190.655 90.4271 190.655 94.5576C190.655 98.6344 188.738 100.881 187.132 102.032C185.267 103.338 183.297 103.705 179.307 103.705H169.615ZM175.576 98.6344H180.084C181.794 98.6344 182.83 98.2158 183.556 97.2747C183.919 96.8047 184.437 95.9676 184.437 94.3998C184.437 92.832 183.919 91.7342 182.883 90.9497C182.261 90.4797 181.431 90.2189 180.032 90.2189H175.576V98.6344Z",
    fill: "#9B9FB3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_41420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.857,
    height: 38,
    fill: "white",
    transform: "translate(85 66)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtb);
export default __webpack_public_path__ + "static/media/vtb.6705491fac5de9bec6da8e5421a96e6a.svg";
export { ForwardRef as ReactComponent };